"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const NAMESPACE = "new-mjf-multi-jet-fusion";

const ICON_BASE = "/image/new-version/more/MJF/icon";

const CARDS = [
	{
		icon: `${ICON_BASE}/Basic Practical Finish.svg`,
		titleKey: "surfaceFinishCard1Title",
		processLabelKey: "surfaceFinishCard1ProcessLabel",
		processDescKey: "surfaceFinishCard1ProcessDesc",
		appLabelKey: "surfaceFinishCard1AppLabel",
		appDescKey: "surfaceFinishCard1AppDesc",
	},
	{
		icon: `${ICON_BASE}/Practical Appearance  Enhancement.svg`,
		titleKey: "surfaceFinishCard2Title",
		processLabelKey: "surfaceFinishCard2ProcessLabel",
		processDescKey: "surfaceFinishCard2ProcessDesc",
		appLabelKey: "surfaceFinishCard2AppLabel",
		appDescKey: "surfaceFinishCard2AppDesc",
	},
	{
		icon: `${ICON_BASE}/Flexible Custom Finish.svg`,
		titleKey: "surfaceFinishCard3Title",
		processLabelKey: "surfaceFinishCard3ProcessLabel",
		processDescKey: "surfaceFinishCard3ProcessDesc",
		appLabelKey: "surfaceFinishCard3AppLabel",
		appDescKey: "surfaceFinishCard3AppDesc",
	},
] as const;

export default function MjfSurfaceFinish() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-[#f6f6f6] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="mb-6 text-center sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
						{t("surfaceFinishTitle")}
					</h2>
					<p className="text-sm leading-relaxed text-black md:text-base">{t("surfaceFinishDesc")}</p>
				</div>

				<div className="grid gap-6 md:grid-cols-3 md:gap-8">
					{CARDS.map((card) => (
						<div key={card.titleKey} className="border-l-4 border-l-[#7cb342] bg-[#fcfff4] p-6 sm:p-8">
							<div className="relative mb-5 h-12 w-12 sm:h-14 sm:w-14">
								<Image src={card.icon} alt="" fill className="object-contain" sizes="56px" />
							</div>
							<h3 className="mb-4 text-lg font-bold text-black sm:text-xl">{t(card.titleKey)}</h3>
							<div className="mb-4">
								<p className="text-sm leading-relaxed text-black md:text-base">
									<span className="font-bold">{t(card.processLabelKey)}</span>
									{t(card.processDescKey)}
								</p>
							</div>
							<div>
								<p className="text-sm leading-relaxed text-black md:text-base">
									<span className="font-bold">{t(card.appLabelKey)}</span>
									{t(card.appDescKey)}
								</p>
							</div>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}
